import { render, staticRenderFns } from "./compareProduct.vue?vue&type=template&id=7d153552&scoped=true&"
import script from "./compareProduct.vue?vue&type=script&lang=js&"
export * from "./compareProduct.vue?vue&type=script&lang=js&"
import style0 from "./compareProduct.vue?vue&type=style&index=0&id=7d153552&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d153552",
  null
  
)

export default component.exports